/**
 * Раннее выставление <link rel="manifest"> для PWA: Chrome подхватывает манифест
 * до долгой инициализации Vue; иначе остаётся Hockey Mini App + logo192/512.
 */

const MAX_AGE_MS = 30 * 24 * 60 * 60 * 1000;

function basePathFromEnv() {
  const b = (typeof process !== 'undefined' && process.env && process.env.BASE_URL) || '/';
  const baseUrl = b.endsWith('/') ? b : `${b}/`;
  return baseUrl.replace(/\/$/, '');
}

export function isSavedIconSettingsFresh(o) {
  if (!o || !o.timestamp) return false;
  return Date.now() - o.timestamp <= MAX_AGE_MS;
}

export function readTeamIconSettings() {
  try {
    const raw = localStorage.getItem('teamIconSettings');
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function preferredManifestTeamId(userTeamIds) {
  const ids = (userTeamIds || []).map((id) => Number(id));
  const set = new Set(ids);
  const s = readTeamIconSettings();
  if (s && s.teamId != null && set.has(Number(s.teamId)) && isSavedIconSettingsFresh(s)) {
    return s.teamId;
  }
  if (ids.length) return userTeamIds[0];
  return null;
}

export function teamManifestHref(teamId) {
  const basePath = basePathFromEnv();
  const path = `${basePath}/team-pwa-manifest.webmanifest?team=${encodeURIComponent(String(teamId))}`;
  return `${window.location.origin}${path}`;
}

export function applyManifestLinkHref(teamId) {
  if (teamId == null || String(teamId) === '') return;
  const href = teamManifestHref(teamId);
  let link = document.querySelector('link[rel="manifest"]');
  if (!link) {
    link = document.createElement('link');
    link.rel = 'manifest';
    document.head.appendChild(link);
  }
  link.href = href;
}

export function applyManifestFromStorageOnly() {
  const s = readTeamIconSettings();
  if (!s || s.teamId == null || !isSavedIconSettingsFresh(s)) return;
  applyManifestLinkHref(s.teamId);
}
